import React from 'react';

/**
 * Generic head-and-shoulders silhouette shown in a player avatar slot when the
 * player has no headshot photo. Fills its container (100% w/h) and inherits color
 * via `currentColor`, so it picks up whatever tint the avatar wrapper sets.
 */
function PlayerSilhouette({ className = '', style = {} }) {
  return (
    <svg
      className={`player-silhouette ${className}`.trim()}
      viewBox="0 0 36 36"
      style={style}
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="18" cy="13.5" r="6.6" />
      <path d="M18 22.4c-7.3 0-13.2 4.7-13.2 11V36h26.4v-2.6c0-6.3-5.9-11-13.2-11Z" />
    </svg>
  );
}

export default PlayerSilhouette;
